import { Component, ElementRef, Input, OnDestroy, ViewChild } from '@angular/core';

@Component({
  selector: 'app-side-panel',
  templateUrl: './side-panel.component.html',
  styleUrl: './side-panel.component.scss'
})
export class SidePanelComponent implements OnDestroy {
  showRightPanel: boolean = false;

  @ViewChild('leftpanel') leftpanel!: ElementRef<HTMLDivElement>;
  @ViewChild('rightpanel') rightpanel!: ElementRef<HTMLDivElement>;
  @ViewChild('panelcontainer') panelcontainer!: ElementRef<HTMLDivElement>;

  @Input() offsetHeight: number = 0;
  @Input() enableAutoResize: boolean = true;
  @Input() panelHeight: number | null = null;

  @Input() set show(value: boolean) {
    if (this.panelcontainer) {
      const panelContainer = this.panelcontainer.nativeElement;
      if (value)
        panelContainer.classList.add('slide');
      else
        panelContainer.classList.remove('slide');

      if (value === true)
        this.showRightPanel = true;
    }
  };

  private observers = new Map<HTMLElement, ResizeObserver>();

  ngAfterViewInit(): void {
    this.addTransitionEndListener();
    this.applyPanelHeight();

    if (this.enableAutoResize) {
      this.resizePanel({ isdisconnect: false, element: this.leftpanel })
    }
  }

  ngOnDestroy() {
    this.resizePanel({ isdisconnect: true, element: this.leftpanel })
    this.resizePanel({ isdisconnect: true, element: this.rightpanel })
  }

  applyPanelHeight(): void {
    if (this.panelHeight !== null) {
      const heightValue = `${this.panelHeight}px`;
      this.panelcontainer.nativeElement.style.height = heightValue;
    }
  }

  resizePanel(panel: { isdisconnect: boolean; element: ElementRef }) {
    // Solo procesar si el auto-resize está habilitado
    if (!this.enableAutoResize) return;

    if (!panel.isdisconnect) {
      if (this.observers.has(panel.element.nativeElement)) return;

      const resizeObserver = new ResizeObserver(entries => {
        for (let entry of entries) {
          const { height } = entry.contentRect;
          this.panelcontainer.nativeElement.style.height = `${height + this.offsetHeight}px`;
        }
      });

      resizeObserver.observe(panel.element.nativeElement);
      this.observers.set(panel.element.nativeElement, resizeObserver);
    } else {
      const observer = this.observers.get(panel.element.nativeElement);
      if (observer) {
        observer.disconnect();
        this.observers.delete(panel.element.nativeElement);
      }
    }
  }

  addTransitionEndListener() {
    const rightPanel = this.rightpanel.nativeElement;

    rightPanel.addEventListener('transitionend', (event: TransitionEvent) => {
      if (event.target === rightPanel && event.propertyName === 'transform') {
        const computedStyle = getComputedStyle(rightPanel);
        const transform = computedStyle.getPropertyValue('transform');

        const values = transform.match(/matrix\(([^)]+)\)/);
        if (values && values[1]) {
          const matrixValues = values[1].split(', ');
          const translateX = parseFloat(matrixValues[4]); // valor en px

          if (translateX === 0) {
            this.resizePanel({ isdisconnect: true, element: this.rightpanel });
            this.resizePanel({ isdisconnect: false, element: this.leftpanel });
            this.showRightPanel = false;
          } else if (translateX < 0) {
            this.resizePanel({ isdisconnect: true, element: this.leftpanel });
            this.resizePanel({ isdisconnect: false, element: this.rightpanel });
          }
        }
      }
    })
  }

}
